const extendedTechRoles = [
  "Technical Manager",
  "Team Lead (Collaboration/Enterprise Networking)",
  "Solutions Engineer",
  "Technology Lead",
  "Sr. Solutions Engineer",
  "Field Technician",
  "Customer Support Engineer",
  "Customer Service Engr.",
  "Customer Support Engineer (En Collab)",
  "Cadet Engineer",
  "Technical Admin Asst.",
  "Technical Support Engineer",
  "Technology Lead (Security)",
  "Technology Lead (Data Center)",
];

const rolePermissions = {
  "/home": ["manager", "supervisor", "agent", "Pasig","compliance","excom", ...extendedTechRoles],
  "/agent-assist": ["manager", "supervisor", "agent"],
  "/rebate-calculator": ["manager", "supervisor", "agent", "training", "excom"],
  "/gnosis": ["manager", "supervisor", "agent"],
  "/user-management": ["manager", "supervisor", "excom"],
  "/admin/announcements": ["manager", "admin","compliance"],

  "/rebate-viewer": ["manager", "supervisor"],
  "/audio-transcriber": ["manager", "Pasig", "supervisor", "excom","compliance"],
  "/agent-assist-gpt4o": ["manager","compliance"],
  "/hrpay": ["manager", "supervisor", "agent", "Pasig","compliance", "excom", ...extendedTechRoles],
  "/settings": ["manager","compliance", "supervisor", "agent", "Pasig", "excom", ...extendedTechRoles],

  "/idp-monitoring": ["manager", "supervisor", "hr", "excom", "agent", ...extendedTechRoles],
  "/password-manager": ["agent"],
  "/qa-audio-transcriber": ["manager", "supervisor", "QA"],
  "/resume-analysis": ["manager", "TA","compliance", ...extendedTechRoles],
  "/coaching-transcriber": ["manager", "supervisor"],
  "/webview": ["manager", ...extendedTechRoles],
  "/tools": ["manager", "supervisor", "agent", "Pasig","compliance", "training", "QA", "tech", "hr", "TA", "excom", ...extendedTechRoles],
  "/chat": [], 
   "/audio-sentiment": ["manager", "supervisor", "excom", "Pasig", ...extendedTechRoles],// Your actual roles
  "/esatsurvey": ["manager","compliance", "supervisor", "agent", "Pasig", "excom", ...extendedTechRoles],
    "/chat": ["admin", "manager", "supervisor", "agent"], // <- add this (adjust roles)
    "/learning": ["admin", "manager", "supervisor", "agent"],



};


// Add these functions at the end of your existing rolePermissions.js file

// Define role hierarchy levels for IDP access
const idpHierarchy = {
  // ORGANIZATION-WIDE ACCESS (Senior + Decision Makers)
  organizationAccess: [
    "excom",
    "hr",
    "manager",
    "Technical Manager",
    "Technology Lead",
    "Technology Lead (Security)",
    "Technology Lead (Data Center)",
    "Sr. Solutions Engineer"
  ],

  // TEAM ACCESS ONLY (Junior Level)
  teamAccess: [
    "supervisor",
    "Team Lead (Collaboration/Enterprise Networking)",
    "Solutions Engineer",
    "Customer Support Engineer",
    "Customer Service Engr.",
    "Customer Support Engineer (En Collab)",
    "Technical Support Engineer"
  ],

  // PERSONAL ACCESS ONLY (Individual Contributors)
  personalOnly: [
    "agent",
    "Field Technician",
    "Cadet Engineer",
    "Technical Admin Asst.",
    "Pasig",
    "training",
    "QA",
    "tech",
    "TA"
  ]
};

// Helper functions for IDP access levels
export const hasOrganizationAccess = (role) => {
  return idpHierarchy.organizationAccess.includes(role);
};

export const canHaveTeamAccess = (role) => {
  return idpHierarchy.teamAccess.includes(role);
};

export const isPersonalOnly = (role) => {
  return idpHierarchy.personalOnly.includes(role);
};

export const getIDPAccessLevel = (role) => {
  if (hasOrganizationAccess(role)) return "organization";
  if (canHaveTeamAccess(role)) return "team";
  if (isPersonalOnly(role)) return "personal";
  return "dynamic"; // For unknown roles, check dynamically
};

export default rolePermissions;
